import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Home } from "./pages/home";
import { CreateInquiry } from "./pages/create-inquiry";
import { PrivacyPolicy } from "./pages/privacy-policy";
import { Navbar } from "./components/navbar";
import Footer from "./components/Footer";
import { TermsAndConditions } from "./pages/terms-and-conditions";

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <div className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/create-inquiry" element={<CreateInquiry />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            />
          </Routes>
        </div>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
